var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwlactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4687_55637)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_4687_55637)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1 4.54242H0.750089C1.11169 4.54242 1.46101 4.69497 1.70676 4.96149L8.06895 11.8625L8.86219 11.002L4.61166 6.39024H6.36175C6.72336 6.39024 7.07267 6.54279 7.31842 6.80931L10.0227 9.74301L12.7271 6.80931C12.9728 6.54279 13.3221 6.39024 13.6837 6.39024H15.4338L11.1833 11.002L11.9767 11.8627L18.339 4.96149C18.5847 4.69497 18.934 4.54242 19.2956 4.54242H21.0457L17.3977 8.49924V11.4121C17.3977 12.3835 16.9852 13.3163 16.2655 13.9686C14.8647 15.2398 12.66 15.1223 11.354 13.7056L10.0228 12.2612L8.69327 13.7038C7.38728 15.1206 5.18431 15.2398 3.78178 13.9668C3.06209 13.3145 2.64958 12.3817 2.64958 11.4103V8.50083L-1 4.54242ZM15.6915 10.3499L13.2462 13.0021C13.4499 13.0883 13.6698 13.1381 13.894 13.1462L13.8922 13.1445C14.3644 13.1602 14.8068 12.9972 15.1403 12.6833C15.4808 12.3642 15.6757 11.9328 15.6915 11.4647V10.3499ZM4.35578 10.3514L6.79918 13.0016C6.59553 13.088 6.3756 13.1381 6.15151 13.1462C5.67932 13.1637 5.23697 12.9989 4.90346 12.6851C4.56292 12.3642 4.36983 11.9328 4.35578 11.4664V11.4103V10.3514ZM10.0216 13.9833L8.86303 15.2423L10.0216 16.4995L11.1819 15.2423L10.0216 13.9833Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4687_55637",
    x1: -0.0147656,
    y1: -0.0156776,
    x2: 19.4651,
    y2: 20.2282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40AEEF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4687_55637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwlactive);
export default __webpack_public_path__ + "static/media/owl.active.7a831aa4e0a5babdd13c999fecefbeec.svg";
export { ForwardRef as ReactComponent };